import React, {createContext, useContext, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../helpers'

// Keep type for compatibility, but only use 'light'
export type ThemeModeType = 'light'

// Only keeping this if you still want to manage menuMode in localStorage
export const themeMenuModeLSKey = 'kt_theme_mode_menu'

type ThemeModeContextType = {
  mode: ThemeModeType
  menuMode: ThemeModeType
  updateMode: (_mode: ThemeModeType) => void
  updateMenuMode: (_mode: ThemeModeType) => void
}

const themeModeSwitchHelper = () => {
  const imageUrl = '/media/patterns/header-bg.jpg'
  document.body.style.backgroundImage = `url("${toAbsoluteUrl(imageUrl)}")`
}

const defaultThemeMode: ThemeModeContextType = {
  mode: 'light',
  menuMode: 'light',
  updateMode: (_mode: ThemeModeType) => {},
  updateMenuMode: (_menuMode: ThemeModeType) => {},
}

const ThemeModeContext = createContext<ThemeModeContextType>(defaultThemeMode)

const useThemeMode = () => useContext(ThemeModeContext)

const ThemeModeProvider = ({children}: {children: React.ReactNode}) => {
  const [mode, setMode] = useState<ThemeModeType>('light')
  const [menuMode, setMenuMode] = useState<ThemeModeType>('light')

  const updateMode = (_mode: ThemeModeType) => {
    setMode('light')
    document.documentElement.setAttribute('data-bs-theme', 'light')
  }

  const updateMenuMode = (_menuMode: ThemeModeType) => {
    setMenuMode('light')
    localStorage.setItem(themeMenuModeLSKey, 'light') // Optional: remove if you want no localStorage at all
  }

  useEffect(() => {
    updateMode('light')
    updateMenuMode('light')
    themeModeSwitchHelper()
  }, [])

  return (
    <ThemeModeContext.Provider value={{mode, menuMode, updateMode, updateMenuMode}}>
      {children}
    </ThemeModeContext.Provider>
  )
}

export {ThemeModeProvider, useThemeMode, themeModeSwitchHelper}
